import React, { useEffect, useState } from "react";
import { apiGet, apiDel } from "../../admin/api";
import PartnerForm from "./PartnerForm";
import PartnerCard from "./PartnerCard";
import "./partners-admin.css";

export default function PartnersAdmin() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);

  const limit = 12;

  const load = async () => {
    setLoading(true);
    try {
      const data = await apiGet(`/api/partners?page=${page}&limit=${limit}`);
      setItems(Array.isArray(data.items) ? data.items : []);
    } catch (e) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page]);

  const onDelete = async (id) => {
    if (!window.confirm("Remove this partner?")) return;

    try {
      await apiDel(`/api/partners/${id}`);
      load();
    } catch (err) {
      alert(err.message);
    }
  };

  const openCreate = () => {
    setEditing(null);
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
    setEditing(null);
  };

  const showPager = page > 1 || (items?.length || 0) === limit;

  return (
    <div className="partners-admin">
      <div className="toolbar">
        <h2 className="toolbar__title">Company Partners</h2>
        <div className="toolbar__actions">
          <button className="btn btn--cta" onClick={openCreate}>
            Add Partner
          </button>
        </div>
      </div>

      {showForm ? (
        <div className="panel">
          <div className="panel__head">
            <h3 className="panel__title">
              {editing ? "Edit Partner" : "Add Partner"}
            </h3>
          </div>

          <PartnerForm
            initial={editing}
            onSaved={() => {
              closeForm();
              load();
            }}
            onCancel={closeForm}
          />
        </div>
      ) : (
        <>
          {loading ? (
            <div className="empty">Loading…</div>
          ) : items.length === 0 ? (
            <div className="empty">
              <div className="empty__icon">🤝</div>
              <div className="empty__title">No partners yet</div>
              <div className="empty__desc">
                Add your first partner company.
              </div>
              <button className="btn btn--cta" onClick={openCreate}>
                Add Partner
              </button>
            </div>
          ) : (
            <div className="grid">
              {items.map((it) => (
                <PartnerCard
                  key={it.id}
                  item={it}
                  onEdit={(m) => {
                    setEditing(m);
                    setShowForm(true);
                  }}
                  onDelete={onDelete}
                />
              ))}
            </div>
          )}

          {showPager && (
            <div className="pager">
              <button
                className="pill"
                disabled={page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              >
                Prev
              </button>

              <span className="badge">Page {page}</span>

              <button className="pill" onClick={() => setPage((p) => p + 1)}>
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}